import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
const navigator = window.navigator as any;
import { Constant } from 'src/app/constants/constant';

import { environment } from 'src/environments/environment';
@Component({
  selector: 'calsoft-share-speed-dial',
  templateUrl: './share-speed-dial.component.html',
  styleUrls: ['./share-speed-dial.component.scss']
})
export class ShareSpeedDialComponent implements OnInit {

  constructor(public platform: Platform) { }

  ngOnInit(): void {

  }

  share(){
    
    let currentURL = window.location.href;

   if(currentURL.includes('localhost')){

    let siteUrl=environment.serverAPI.split('/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT')[0]+'/'

    currentURL=window.location.href.replace("https://localhost/",siteUrl)
   }

    var options = {
      subject: 'the subject', // fi. for email
      files: ['', ''], // an array of filenames either locally or remotely
      url: currentURL,
  

    };
   
    if (navigator.share) {
      navigator
        .share({
          title: Constant.siteName,
          url: currentURL
        })
        .then(() => "sa")
        .catch(error =>"sa");
    } else {
      alert('share not supported');
    }
  }


}
